import {Box, Button, makeStyles} from "@material-ui/core";
import {useEffect} from "react";
import UtilService from "../../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import {moveNextPage, updateCreatorOnboarding} from "../../../../../store/actions/creator/creatorOnBoarding";
import {useDispatch, useSelector} from "react-redux";

const useStyles = makeStyles(() => ({
  title: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: (props: any) => props.height < 740 ? 10 : 0,
    '& p': {
      margin: 0,
      maxWidth: 800,
      textAlign: 'center',
      fontSize: 36,
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      lineHeight: 1.25,
      '@media (max-width: 600px)': {
        fontSize: '25px!important',
      },
    }
  },
  description: {
    fontFamily: 'roboto-light',
    fontSize: (props: any) => props.height < 740 ? 20 : 24,
    color: '#212D40',
    textAlign: 'center',
    lineHeight: 1.25,
    '@media (max-width: 600px)': {
      fontSize: '15px!important',
    },
  },
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    width: 240,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    '@media (max-width: 600px)': {
      padding: '3px 12px',
      fontSize: 11,
      width: 'auto',
      height: 'auto'
    }
  },
  img: {
    width: (props: any) => props.height < 740 ? 500 : 600,
    height: 'auto',
    margin: '30px 0',
    '@media (max-width: 520px)': {
      width: 'calc(100% - 20px)!important',
    },

  }
}));

const Module3Slide2 = () => {
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm3s2');
  }, []);

  const onStartModule4 = () => {
    if (Number(activepage.value) < 14) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '14',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));

      const reqActiveStep = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activestep.id,
        preference_name: 'ACTIVESTEP',
        preference_information: '3',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActiveStep));
    }

    dispatch(moveNextPage(14))
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <div className={classes.title}>
        <p>
          Awesome. Congrats on Completing Module 3! 
          We’re super excited to meet with you!
        </p>
      </div>
      <div className={classes.description}>
        You should have an email confirming our session.
      </div>
      <img className={classes.img} src={'/assets/icons/onboarding/module3-slide2.svg'} alt={'Image'} />
      <div className={classes.description}>
        When you’re ready, check out your first results in Module 4.
      </div>
      <Box mt={2} mb={1} display='flex' flexDirection='row' alignItems='center' justifyContent='center' style={{ position: 'relative' }}>
        <Button color='primary' size='large' className={classes.btn} onClick={onStartModule4}>
          Start Module 4
        </Button>
      </Box>
    </div>
  )
};

export default Module3Slide2;